import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    document.querySelector('.nav').addEventListener('click',function(){
      window.scroll(0,0);
    });

    function dropMenu_link(){
      var nav = document.querySelector(".nav");
      nav.addEventListener('click',function(){
        nav.classList.remove('active');
      })
    }

    function dropMenu_behavior(){
      var dropMenu = document.querySelector(".burger-menu");
      dropMenu.addEventListener('click',function(){
        document.querySelector('.nav').classList.toggle('active');
        dropMenu_link(); 
      });
    }

    dropMenu_behavior();

    document.addEventListener("DOMContentLoaded", function () {
        var nav = document.querySelector(".header");

        document.onscroll = function(){
          nav.classList.add('scroll');
          if(window.scrollY <= 10){
            nav.classList.remove('scroll');
          }
        }
    });
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/corpo-leve-www/www/src/app/elements/header/header.component.ts